import { c as _c } from "react/compiler-runtime";
import { useDebounceValue } from '@sprd/sprd-component-kit/v2';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useLocale } from 'next-intl';
import { useCurrency } from '@/hooks/useCurrency';
import { getShippingOptionsQueryOptions } from '@/app/[abTest]/[locale]/(spreadshirt)/cyo/assortment/detail/components/ProductUsps/getShippingOptionsQueryOptions';
import { getCountry } from '@/utility/locale';
import { getCheapestShippingOption } from '@/utility/shippingOptions';
type UseVolumeDiscountShippingParams = {
  shopId: string;
  productTypeIds: string;
  printTypeIds: string;
  totalQuantity: number;
  totalPrice: number;
};
export function useVolumeDiscountShipping(t0) {
  const $ = _c(25);
  const {
    shopId,
    productTypeIds,
    printTypeIds,
    totalQuantity,
    totalPrice
  } = t0;
  const locale = useLocale();
  const {
    data: currencyCode
  } = useCurrency();
  const selectedCountry = getCountry(locale);
  const debouncedQuantity = useDebounceValue(totalQuantity, 500);
  const debouncedPrice = useDebounceValue(totalPrice, 500);
  const debouncedProductTypeIds = useDebounceValue(productTypeIds, 500);
  const debouncedPrintTypeIds = useDebounceValue(printTypeIds, 500);
  const t1 = getShippingOptionsQueryOptions({
    shopId,
    locale,
    productTypeIds: debouncedProductTypeIds,
    printTypeIds: debouncedPrintTypeIds.split(",").filter(Boolean),
    countryIsoCode: selectedCountry,
    currencyCode,
    quantity: debouncedQuantity,
    totalPrice: debouncedPrice
  });
  const t2 = debouncedQuantity > 0 && debouncedProductTypeIds !== "";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      ...t1,
      enabled: t2
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    data: options,
    isFetching
  } = useQuery(t3);
  const [chosenShippingTypeId, setChosenShippingTypeId] = useState();
  const isOrderEmpty = debouncedQuantity === 0;
  let t4;
  if ($[3] !== options) {
    t4 = options && getCheapestShippingOption(options);
    $[3] = options;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const cheapestOption = t4;
  let t5;
  if ($[5] !== cheapestOption || $[6] !== isOrderEmpty || $[7] !== options) {
    t5 = isOrderEmpty && cheapestOption ? options?.map(option => option === cheapestOption ? {
      ...option,
      price: 0
    } : option) : options;
    $[5] = cheapestOption;
    $[6] = isOrderEmpty;
    $[7] = options;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const shippingOptions = t5;
  let t6;
  if ($[9] !== cheapestOption || $[10] !== chosenShippingTypeId || $[11] !== options) {
    t6 = options?.find(option_0 => option_0.shippingTypeId === chosenShippingTypeId) ?? cheapestOption;
    $[9] = cheapestOption;
    $[10] = chosenShippingTypeId;
    $[11] = options;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const selectedOption = t6;
  const threshold = cheapestOption?.freeShippingThreshold;
  const amountToFreeShipping = threshold !== undefined && !isOrderEmpty ? Math.max(0, Math.round((threshold - debouncedPrice) * 100) / 100) : undefined;
  const t7 = selectedOption?.shippingTypeId;
  const t8 = selectedOption?.title;
  const t9 = selectedOption?.price;
  const t10 = selectedOption?.minDays;
  const t11 = selectedOption?.maxDays;
  let t12;
  if ($[13] !== t10 || $[14] !== t11 || $[15] !== t8 || $[16] !== t9) {
    t12 = {
      shippingName: t8,
      cost: t9,
      minDays: t10,
      maxDays: t11
    };
    $[13] = t10;
    $[14] = t11;
    $[15] = t8;
    $[16] = t9;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== amountToFreeShipping || $[19] !== isFetching || $[20] !== isOrderEmpty || $[21] !== shippingOptions || $[22] !== t12 || $[23] !== t7) {
    t13 = {
      shippingOptions,
      isFetching,
      isOrderEmpty,
      selectedShippingTypeId: t7,
      selectedShippingMethod: t12,
      selectShipping: setChosenShippingTypeId,
      amountToFreeShipping
    };
    $[18] = amountToFreeShipping;
    $[19] = isFetching;
    $[20] = isOrderEmpty;
    $[21] = shippingOptions;
    $[22] = t12;
    $[23] = t7;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
}